<template>
<div class="nav-result">
  <ButtonSquare button-type="-back" @click="goToTop()">{{ $t('btn.back', null, 'localeCommon') }}</ButtonSquare>
  <div class="ranking-window">
    <ul class="text-link">
      <li class="item" @click="goToResultList(1)">
        <span v-html="$t('text013', null, 'localeResult')" />
      </li>
      <li class="item" @click="goToResultList(2)">
        <span v-html="$t('text014', null, 'localeResult')" />
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import ButtonSquare from '@components/global/button-square.vue'

import localeResult from '@locales/result'
import localeCommon from '@locales/common'

export default {
  $messages: { localeResult, localeCommon },
  components: {
    ButtonSquare,
  },
  computed: {
    locale() {
      return this.$route.params.lang ? this.$route.params.lang : 'ja-JP'
    },
  },
  methods: {
    goToTop() {
      this.$router.push(`/${this.locale}`)
      window.scrollTo(0, 0)
    },
    goToResultList(page){
      this.$router.push({ path:`/${this.locale}/result-list`, query: { page: page } },() => {}, () => {})
      window.scrollTo(0, 0)
    }
  },
}
</script>

<style lang="scss" scoped>
.nav-result {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px 40px;
  padding-top: 20px;
}

.button-decoration {
  margin-bottom: -26px;
  position: relative;
  z-index: 10;
}
.ranking-window {
  height: 109px;
  box-sizing: border-box;
  flex: 1 0 0;
  border-style: solid;
  border-width: 48px;
  border-image: url(#{$img-path}result/bg_result-ranking.png) 48 fill stretch;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $fs-large * 1.2;
}
.text-link {
  position: relative;
  text-align: center;
  margin: -48px;
  > .item {
    text-align: center;
    width: 190px;
    display: inline-block;
    white-space: nowrap;
    span {
      text-decoration: underline;
      @include tap-event();
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
